import { useRef, useState } from "react";
import {
	Edit,
	useGetOne,
	useNotify,
	useRedirect,
	useRefresh,
	useTranslate,
	useUpdate,
} from "react-admin";
import { checkIfExists } from "../../utils/customFunctions";
import { requiredPermissions, requiredStatuses } from "./shared";
import { HandoutForm } from "./HandoutForm";

export const HandoutEdit = (props) => {
	const hasRequiredStatus = useRef(false);
	const hasPermission = useRef(false);
	const [isLoading, setIsLoading] = useState(false);
	let { data: handout, loading } = useGetOne("handouts", props.id);
	const translate = useTranslate();
	const redirect = useRedirect();
	const refresh = useRefresh();
	const notify = useNotify();
	const [update] = useUpdate("handouts", props.id);

	const onSuccess = () => {
		notify(translate("handouts.edit.success"), "info");
		setIsLoading(false);
		redirect("/handouts");
		refresh();
	};

	const onFailure = (error) => {
		notify(error.message, "warning");
		setIsLoading(false);
	};

	const handleSave = (transformedData) => {
		setIsLoading(true);
		update(
			{ payload: { data: transformedData } },
			{
				onSuccess,
				onFailure,
			}
		);
	};

	// Permission checks (keeping existing logic)
	if (props.permissions) {
		hasPermission.current = checkIfExists(
			props.permissions,
			requiredPermissions
		);
	}

	if (props.status) {
		hasRequiredStatus.current = checkIfExists(
			props.status,
			requiredStatuses
		);
	}

	if (!hasPermission.current && !hasRequiredStatus.current) {
		notify(translate("permissions.notAllowed"), "warning");
		redirect("/handouts");
		return null;
	}

	return (
		<>
			{loading ? (
				<center>
					<h1>Loading...</h1>
				</center>
			) : (
				<Edit
					{...props}
					title={translate("handouts.edit.title")}
					mutationMode="pessimistic"
				>
					<HandoutForm
						isEdit={true}
						onSave={handleSave}
						isLoading={isLoading}
						handout={handout}
					/>
				</Edit>
			)}
		</>
	);
};